import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'

// VIEWS

import constConf from './constconf'
const Home = () => import(/* webpackChunkName: "home" */ './views/Home')
const AppVk = () => import(/* webpackChunkName: "app_vk" */ './views/AppVk')
const Login = () => import(/* webpackChunkName: "login" */ './views/Login')
const Bot = () => import(/* webpackChunkName: "bot" */ './views/bot/Index')
const Details = () => import(/* webpackChunkName: "details" */ './views/Details')
const BotIndex = () => import(/* webpackChunkName: "bot_index" */ './views/Bot')
const BotCard = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Card')
const BotCatalog = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Catalog')
const BotDelivery = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Delivery')
const BotMessage = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Message')
const BotVariable = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Variables')
const BotModule = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Module')
const BotMailing = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Mailing')
const BotOrder = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Order')
const BotPost = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Post')
const BotPromo = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Promo')
const BotEvent = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Event')
const BotClient = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Client')
const BotJump = () => import(/* webpackChunkName: "bot_index" */ './views/bot/Jump')
const Stats = () => import(/* webpackChunkName: "bot_stats" */ './views/bot/Stats')
const Tag = () => import(/* webpackChunkName: "bot_stats" */ './views/bot/Tag')
const Tool = () => import(/* webpackChunkName: "bot_stats" */ './views/bot/Tool')
const Im = () => import(/* webpackChunkName: "bot_im" */ './views/bot/Im')

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VuetifyDialog)
Vue.use(Vuetify)

Vue.use(VueRouter)

let router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: {
                guest: true
            }
        },
        {
            path: '/bot*',
            component: Bot,
            children: [
                {
                    path: 'card*',
                    name: 'bot-card',
                    component: BotCard,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'catalog*',
                    name: 'bot-catalog',
                    component: BotCatalog,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'delivery*',
                    name: 'bot-delivery',
                    component: BotDelivery,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'variable*',
                    name: 'bot-variable',
                    component: BotVariable,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'message*',
                    name: 'bot-message',
                    component: BotMessage,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'mailing*',
                    name: 'bot-mailing',
                    component: BotMailing,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'post*',
                    name: 'bot-post',
                    component: BotPost,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'promo/:promoId',
                    name: 'bot-promo-form',
                    component: BotPromo,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'promo*',
                    name: 'bot-promo',
                    component: BotPromo,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'order/:orderId',
                    name: 'bot-order-form',
                    component: BotOrder,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'order*',
                    name: 'bot-order',
                    component: BotOrder,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'event*',
                    name: 'bot-event',
                    component: BotEvent,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'im*',
                    name: 'bot-im',
                    component: Im,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'client:groupId',
                    name: 'bot-group-form',
                    component: BotClient,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'client/:clientId',
                    name: 'bot-client-form',
                    component: BotClient,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'client',
                    name: 'bot-client',
                    component: BotClient,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'jump*',
                    name: 'bot-jump',
                    component: BotJump,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'module*',
                    name: 'bot-module',
                    component: BotModule,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'stats*',
                    name: 'bot-stats',
                    component: Stats,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'tag*',
                    name: 'bot-tag',
                    component: Tag,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'tool*',
                    name: 'bot-tool',
                    component: Tool,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: '',
                    name: 'bot-index',
                    component: BotIndex,
                    meta: {
                        requiresAuth: true
                    }
                }
            ],
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/details/:Pid',
            name: 'Details',
            component: Details,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: '/signup',
            name: 'SignUp',
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: '/send_message_password_reset',
            name: 'SendMessagePasswordReset',
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: '/password_reset',
            name: 'PasswordReset',
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: '/appvk',
            name: 'AppVk',
            component: AppVk,
            meta: {
                guest: true
            },
            children: [
                {
                    path: 'home*',
                    name: 'appvk-home',
                    component: AppVk,
                    meta: {
                        guest: true
                    }
                },
                {
                    path: 'mailing_groups*',
                    name: 'appvk-mailing_groups',
                    component: AppVk,
                    meta: {
                        guest: true
                    }
                }]
        }
    ]
})

router.beforeEach((to, from, next) => {
    let _identity = 'id'
    let paternToFindCookie = new RegExp('user' + '=([^;]){1,}')
    let cookie = paternToFindCookie.exec(document.cookie)
    if (cookie != null) {
        if (cookie) cookie = cookie[0].split('=')
        else _identity = false
        _identity = cookie[1] ? cookie[1] : false
    }

    if (to.matched.some(record => record.meta.requiresAuth)) { // страницы для авторизованных пользователей
        if (_identity !== 'login') {
            if (to.query.user_login && to.query.user_login === 'success') {
                axios.defaults.withCredentials = true
                axios.get(constConf.user.url + '/user/profile').then(response => {
                    if (response.data != null && response.data.length !== 0) {
                        let cookieName = 'user'
                        let attribute = 'login'
                        let addDays = 1
                        let date = new Date()
                        date.setDate(date.getDate() + addDays)
                        document.cookie = cookieName + '=' + attribute + (addDays ? '; expires=' + date.toUTCString() : '')
                        next('/bot')
                    }
                    // eslint-disable-next-line handle-callback-err
                }).catch((error) => {
                    console.log('error get user' + error)
                })
            } else {
                next({
                    path: '/login',
                    params: { nextUrl: to.fullPath }
                })
            }
        } else {
            next()
        }
    } else if (to.matched.some(record => record.meta.guest)) { // страницы для не авторизованных пользователей
        if (to.path === '/login' && _identity === 'login') {
            next('/bot')
        } else {
            if (to.query.hash && to.query.uid) {
                axios.defaults.withCredentials = true
                axios.post(constConf.user.url + '/user/loginbyvk', to.query).then(response => {
                    if (response.data.error) {
                        next('/login?error=' + Object.keys(response.data.error)[0])
                    } else {
                        let cookieName = 'user'
                        let attribute = 'login'
                        let addDays = 1
                        let date = new Date()
                        date.setDate(date.getDate() + addDays)
                        document.cookie = cookieName + '=' + attribute + (addDays ? '; expires=' + date.toUTCString() : '')
                        next('/bot')
                    }
                    // eslint-disable-next-line handle-callback-err
                }).catch((error) => {
                    console.log('Ошибка в запросе расчета hash')
                })
            } else {
                next()
            }
        }
    } else {
        next()
    }
})

export default router
